<script lang="ts">
  import { IUiPromo, promoStore } from '@centerhealth/fe/discounts';
  import { ModalService } from '@centerhealth/fe/stores';
  import { UrlService } from '@centerhealth/fe/url';
  import { danger, success, showPromoValidatedToast } from '@centerhealth/fe/toast';
  import { HttpService } from '@centerhealth/fe/http';
  import to from 'await-to-js';

  // Handle modals
  const store = ModalService.store;
  $: modals = $store;

  // Handle success message
  export let queryParams: URLSearchParams;
  // eslint-disable-next-line @typescript-eslint/ban-types
  export let goto: Function;
  export let browser = false;

  let service: UrlService;
  $: service = new UrlService(queryParams, goto);

  const validateDiscountCode = async ({ detail }: { detail: string }): Promise<void> => {
    const [err, validatedPromoDetails] = await to<IUiPromo, unknown>(
      HttpService.get<IUiPromo>(`/v1/subscribe/discount/check?code=${detail}`)
    );

    if (err) {
      danger('Oops, something went wrong');
    } else {
      promoStore.set(validatedPromoDetails);
      showPromoValidatedToast(validatedPromoDetails);
      service.removeQueryParams(['promo', 'pr', 'referral']);
    }
  };

  $: {
    if (browser) {
      // If we have a scmsg => show it and remove it from the url
      const successMsg = service.queryParams.successMsg;
      if (successMsg) {
        success(successMsg);
        service.removeQueryParam('successMsg', { update: true, replace: true });
      }

      // If we have a referral query params handle the logic and update the store
      const promoParam = service.queryParams['promo'] || service.queryParams['referral'];
      if (promoParam) void validateDiscountCode({ detail: promoParam });
    }
  }
</script>

{#each modals as entity}
  <svelte:component
    this={entity.modal}
    visible={!!entity.modal}
    on:close={entity.onClose}
    on:submit={entity.onSubmit}
    {...entity.data}
  />
{/each}
